import { Widget } from './widget';

export enum BrandclubPageType {
  Home = 'Home',
  Category = 'Category',
  CustomCategoryGroup = 'CustomCategoryGroup',
  Subcategory = 'Subcategory',
  Explore = 'Explore',
  Collection = 'Collection',
  Editorial = 'Editorial',
  Product = 'Product',
  Search = 'Search',
}

export enum PageStatus {
  Visible = 'VISIBLE',
  NotVisible = 'NOT_VISIBLE',
}

export interface ContainerConfig {
  width?: number;
}

export interface Page {
  id?: string;
  childPages?: Page[];
  widgets?: Widget[]; // Order here will determine render order
  status: PageStatus;
  containerConfigOverride?: {
    mobile?: ContainerConfig;
    tablet?: ContainerConfig;
    desktop?: ContainerConfig;
  } & ContainerConfig;
  metaDescription: string;
  title: string;
  displayName: string;
  route: string;
  entityId?: string;
  pageType: BrandclubPageType;
  entityType?: string;
  canBeEdited?: boolean;
  canBeReordered?: boolean;
  canBeDeleted?: boolean;
  previewImageUrl?: string;
  showInNavigation?: boolean;
  canBeHidden?: boolean;
  createdTime?: number;
}

export type PageTemplate = {
  templateId: string;
  childPageTemplateIds?: string[]; // Order here will determine render order
  widgetTemplateIds?: string[]; // Order here will determine render order
  status: PageStatus;
  metaDescription: string;
  containerConfigOverride?: {
    mobile?: ContainerConfig;
    tablet?: ContainerConfig;
    desktop?: ContainerConfig;
  } & ContainerConfig;
  title: string;
  route: string;
  entityId?: string;
  pageType: BrandclubPageType;
  entityType?: string;
  canBeReordered?: boolean; // Default: true, if false, Page cannot be reordered in the pages hierarchy
  canBeDeleted?: boolean; // Default: true, if false, Page cannot be reordered in the pages hierarchy
};
